import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const sid = sp.get("session_id");
  const ctx = sp.get("ctx");
  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      if (!sid) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || tries > 8) { setStatus("error"); return; }
      } catch { if (tries > 8) { setStatus("error"); return; } }
      tries++; setTimeout(poll, 2000);
    };
    poll();
  }, [sid]);
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-lg p-10 text-center max-w-sm w-full" data-testid="payment-success">
        {status === "checking" && <p className="text-slate-500">Confirming your payment…</p>}
        {status === "paid" && (ctx === "wallet"
          ? <><CheckCircle2 size={56} className="text-emerald-600 mx-auto" /><h1 className="text-xl font-bold mt-3">Wallet Recharged!</h1><p className="text-slate-500 text-sm mt-1">Ab wallet se koi bhi POS plan turant activate karein.</p><button data-testid="pay-goto-pos" onClick={() => nav("/seller/pos")} className="mt-5 bg-blue-600 text-white rounded-xl px-6 py-2.5 font-bold">Go to POS</button></>
          : <><CheckCircle2 size={56} className="text-emerald-600 mx-auto" /><h1 className="text-xl font-bold mt-3">Payment Successful!</h1><p className="text-slate-500 text-sm mt-1">Your order is confirmed.</p><button onClick={() => nav("/orders")} className="mt-5 bg-emerald-600 text-white rounded-xl px-6 py-2.5 font-bold">View Orders</button></>)}
        {status === "error" && <><XCircle size={56} className="text-red-500 mx-auto" /><h1 className="text-xl font-bold mt-3">Payment Pending</h1><p className="text-slate-500 text-sm mt-1">We couldn't confirm yet. Check My Orders shortly.</p><button onClick={() => nav("/orders")} className="mt-5 bg-slate-900 text-white rounded-xl px-6 py-2.5 font-bold">My Orders</button></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-lg p-10 text-center max-w-sm" data-testid="payment-cancel">
        <XCircle size={56} className="text-orange-500 mx-auto" /><h1 className="text-xl font-bold mt-3">Payment Cancelled</h1>
        <p className="text-slate-500 text-sm mt-1">Your order was not completed.</p>
        <button onClick={() => nav("/")} className="mt-5 bg-emerald-600 text-white rounded-xl px-6 py-2.5 font-bold">Back to Shop</button>
      </div>
    </div>
  );
}
